import {useUserProperty} from '../../../../hooks/useUserProperty'
import {UserProperties} from '../../../../utils/userProperties'
import Link from '../../../common/Link/Link'

export default function FavoriteBuildsSettingsMessage() {
  const addTriggeredBuildToFavorites = useUserProperty(
    UserProperties.ADD_TRIGGERED_BUILD_TO_FAVORITES,
  )

  if (addTriggeredBuildToFavorites !== 'true') {
    return null
  }

  return (
    <div>
      {
        'All manually triggered builds are added to favorites. This behavior can be disabled in the '
      }
      <Link href="/profile.html" relative>
        {'user profile settings'}
      </Link>
      {'.'}
    </div>
  )
}
